module.exports = __webpack_public_path__ + "static/media/Notification-ShipmentDelay-Push-Preview.523a830e.png";